import { render } from "./EventCard.vue?vue&type=template&id=1ef821d8&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=1ef821d8&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/.pnpm/vue-loader@16.8.1_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ef821d8"]])

export default __exports__